export default __webpack_public_path__ + "images/eed8265a66dafb9199ce2293d1df15f7.png";